export default "__VITE_ASSET__oI5Xcdwp__"